/**
 * @file CustomerMetrics.tsx
 * @description Четыре компактные плитки показателей клиента (phase19.31,
 * SC63 с уточнением владельца 2026-10-02): «Сумма покупок», «Заказов»,
 * «Средний чек», «Последний заказ».
 *
 * Общий `MetricTile` (как на «Обзоре склада») в компактном виде: белая
 * карточка высотой ~76px, значение 20px/600 вместо 24–28px — через
 * переменную шкалы `--fs-metric` на плитке, сам общий компонент не
 * меняется. Раскладка: телефон — 2×2, от 768 — четыре в ряд.
 */

import { buildCustomerMetrics } from "./customer-info";
import { MetricTile } from "../../ui/MetricTile";
import type { CustomerStatsDto } from "../../../lib/api-customers";

/** Компактная плитка: ниже и мельче значение, цифры табличные. */
const COMPACT_TILE = "min-h-[76px] gap-0.5 p-3 lg:p-3 tabular-nums [--fs-metric:1.25rem]";

export function CustomerMetrics({ stats }: { stats: CustomerStatsDto | null }) {
  return (
    <section aria-label="Показатели клиента" className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-3">
      {buildCustomerMetrics(stats).map((m) => (
        <MetricTile key={m.key} label={m.label} value={m.value} hint={m.hint} className={COMPACT_TILE} />
      ))}
    </section>
  );
}
